<template>
  <div>
    <div class="navigation">
      <div @click="linkToUserRoot()">
        <div class="top-logo">
          <!-- <img src="@/assets/firmwide-icon-white.svg" /> -->
          <img src="@/assets/icon-legalleria.svg"/>
        </div>
      </div>
      <router-link
        to="/"
        v-if="checkUserAllowedModules(0)"
        :class="['nav-item', 'fill', $route.path == '/' ? 'active' : '']"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="29"
          height="29"
          viewBox="0 0 29 29"
        >
          <g>
            <g>
              <path
                d="M12.982 3.257v6.468a3.26 3.26 0 0 1-3.257 3.257H3.257A3.26 3.26 0 0 1 0 9.725V3.257A3.26 3.26 0 0 1 3.257 0h6.468a3.26 3.26 0 0 1 3.257 3.257zm-2.2 0c0-.583-.474-1.057-1.057-1.057H3.257c-.583 0-1.057.474-1.057 1.057v6.468c0 .583.474 1.057 1.057 1.057h6.468c.583 0 1.056-.474 1.056-1.057zm17.382.043v6.381c0 1.82-1.48 3.301-3.3 3.301h-6.381c-1.82 0-3.3-1.48-3.3-3.3V3.3c0-1.82 1.48-3.3 3.3-3.3h6.38c1.82 0 3.301 1.48 3.301 3.3zm-2.2 0c0-.606-.494-1.1-1.1-1.1h-6.381c-.607 0-1.1.494-1.1 1.1v6.381c0 .607.493 1.1 1.1 1.1h6.38c.607 0 1.1-.493 1.1-1.1zM12.982 18.44v6.467a3.26 3.26 0 0 1-3.257 3.257H3.257A3.26 3.26 0 0 1 0 24.907V18.44a3.26 3.26 0 0 1 3.257-3.257h6.468a3.26 3.26 0 0 1 3.257 3.257zm-2.2 0c0-.584-.474-1.058-1.057-1.058H3.257c-.583 0-1.057.474-1.057 1.057v6.468c0 .583.474 1.057 1.057 1.057h6.468c.583 0 1.056-.474 1.056-1.057zm17.382.043v6.38c0 1.82-1.48 3.301-3.3 3.301h-6.381c-1.82 0-3.3-1.48-3.3-3.3v-6.381c0-1.82 1.48-3.301 3.3-3.301h6.38c1.82 0 3.301 1.48 3.301 3.3zm-2.2 0c0-.607-.494-1.1-1.1-1.1h-6.381c-.607 0-1.1.493-1.1 1.1v6.38c0 .607.493 1.1 1.1 1.1h6.38c.607 0 1.1-.493 1.1-1.1z"
              />
            </g>
          </g>
        </svg>
        <div class="nav-item-hover">{{ $t("components.nav_left.l_1") }}</div>
      </router-link>
      <div
        :class="[
          'nav-item',
          'fill',
          $route.path.includes('/case') ||
          $route.path.includes('/archived-case')
            ? 'active'
            : '',
        ]"
      >
        <router-link to="/cases" v-if="checkUserAllowedModules(1)">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="30"
            height="30"
            viewBox="0 0 30 30"
          >
            <g>
              <g>
                <path
                  d="M29.248 16.733v.32c0 1.245-.69 2.783-1.8 4.015-1.263 1.4-2.82 2.17-4.385 2.17s-3.122-.77-4.384-2.17c-1.11-1.232-1.8-2.77-1.8-4.015v-.32l4.494-7.491-4.777-1.896c-.238.231-.515.42-.817.555v16.435h2.912L21.523 30H7.725l2.832-5.664h2.912V7.901a2.846 2.846 0 0 1-.817-.555L7.875 9.241l4.495 7.492v.32c0 1.245-.69 2.783-1.8 4.015-1.263 1.4-2.82 2.17-4.385 2.17s-3.122-.77-4.384-2.17C.691 19.836 0 18.298 0 17.053v-.32L5.396 7.74 11.795 5.2a2.84 2.84 0 0 1 1.674-2.47V.751h2.31v1.98a2.84 2.84 0 0 1 1.675 2.47l6.398 2.539zm-2.63 1.475h-7.11a5.697 5.697 0 0 0 1.236 1.674c.513.477 1.333 1.045 2.319 1.045s1.806-.568 2.32-1.045a5.695 5.695 0 0 0 1.235-1.674zm-.565-2.31l-2.99-4.983-2.99 4.982zM17.785 27.69l-.522-1.043h-5.278l-.522 1.043zM14.103 5.316a.522.522 0 1 0 1.044-.001.522.522 0 0 0-1.044.001zM3.866 19.882c.513.477 1.333 1.045 2.319 1.045s1.806-.568 2.32-1.045a5.696 5.696 0 0 0 1.235-1.674H2.63a5.692 5.692 0 0 0 1.236 1.674zm5.309-3.985l-2.99-4.982-2.99 4.982z"
                />
              </g>
            </g>
          </svg>
        </router-link>
        <div class="nav-item-hover">{{ $t("components.nav_left.l_2") }}</div>
      </div>
      <router-link
        to="/kalendar"
        :class="[
          'nav-item',
          'fill',
          $route.path == '/kalendar' ? 'active' : '',
        ]"
        v-if="checkUserAllowedModules(2)"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="28"
          height="28"
          viewBox="0 0 28 28"
        >
          <g>
            <g>
              <path
                d="M27.632 5.472v18.951a3.238 3.238 0 0 1-3.238 3.23H3.238A3.238 3.238 0 0 1 0 24.423V5.472a3.238 3.238 0 0 1 3.238-3.23h1.295V.087h2.16V2.24H20.94V.088h2.159V2.24h1.295a3.238 3.238 0 0 1 3.238 3.23zm-2.159 4.738H2.16v14.213a1.08 1.08 0 0 0 1.08 1.077h21.155a1.08 1.08 0 0 0 1.08-1.077zm0-4.738a1.08 1.08 0 0 0-1.08-1.077H23.1V6.55h-2.16V4.395H6.693V6.55H4.533V4.395H3.238a1.08 1.08 0 0 0-1.08 1.077v2.584h23.315zM4.102 12.47H6.26v2.153H4.102zm4.317 0h2.159v2.153H8.419zm4.318 0h2.158v2.153h-2.158zm4.317 0h2.159v2.153h-2.159zm4.318 0h2.158v2.153h-2.158zm-17.27 4.307H6.26v2.153H4.102zm4.317 0h2.159v2.153H8.419zm4.318 0h2.158v2.153h-2.158zm4.317 0h2.159v2.153h-2.159zM4.102 21.085H6.26v2.153H4.102zm4.317 0h2.159v2.153H8.419zm4.318 0h2.158v2.153h-2.158zm4.317 0h2.159v2.153h-2.159zm4.318-4.307h2.158v2.153h-2.158z"
              />
            </g>
          </g>
        </svg>
        <div class="nav-item-hover">{{ $t("components.nav_left.l_3") }}</div>
      </router-link>
      <router-link
        to="/osobe"
        :class="[
          'nav-item',
          'fill',
          $route.path.includes('/osobe') || $route.path.includes('/institucije')
            ? 'active'
            : '',
        ]"
        v-if="checkUserAllowedModules(3)"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="31"
          height="31"
          viewBox="0 0 31 31"
        >
          <g>
            <g>
              <path
                d="M5.14 17.018a12.366 12.366 0 0 1 6.182-4.802 6.548 6.548 0 0 1-2.38-5.052C8.942 3.55 11.88.609 15.49.609s6.547 2.94 6.547 6.555c0 2.045-.94 3.875-2.411 5.078 2.452.879 4.599 2.523 6.096 4.75a1.158 1.158 0 1 1-1.923 1.295 10.055 10.055 0 0 0-8.36-4.452c-3.37 0-6.5 1.672-8.372 4.473a1.157 1.157 0 0 1-1.607.32 1.16 1.16 0 0 1-.319-1.61zm6.12-9.854a4.237 4.237 0 0 0 4.23 4.234c2.331 0 4.229-1.9 4.229-4.234a4.237 4.237 0 0 0-4.23-4.235c-2.332 0-4.23 1.9-4.23 4.235zm8.85 13.987l-1.727 1.248a.727.727 0 0 0-.267.815l.696 2.018c.03.09.04.178.037.262-.025.542-.703.913-1.201.553L15.92 24.8a.735.735 0 0 0-.862 0l-1.727 1.247c-.498.36-1.18-.01-1.201-.553a.742.742 0 0 1 .037-.262l.695-2.018a.727.727 0 0 0-.266-.815l-1.728-1.248c-.574-.415-.28-1.4.431-1.4h2.136c.317 0 .599-.122.697-.423l.66-2.031a.72.72 0 0 1 .697-.504.72.72 0 0 1 .698.504l.66 2.031c.098.3.38.423.697.423h2.135c.71 0 1.006.985.431 1.4zm9.908 4.06L28.29 26.46a.727.727 0 0 0-.266.815l.695 2.019c.03.09.041.178.037.261-.024.543-.703.913-1.2.554l-1.728-1.248a.735.735 0 0 0-.862 0l-1.728 1.248c-.498.36-1.18-.011-1.201-.554a.748.748 0 0 1 .038-.261l.695-2.019a.727.727 0 0 0-.267-.815l-1.727-1.248c-.575-.415-.28-1.4.43-1.4h2.136c.318 0 .6-.122.697-.422l.66-2.032a.72.72 0 0 1 .698-.504.72.72 0 0 1 .697.504l.66 2.032c.098.3.38.423.697.423h2.136c.71 0 1.005.984.43 1.4zm-19.815 0L8.475 26.46a.727.727 0 0 0-.266.815l.696 2.019c.03.09.04.178.037.261-.025.543-.704.913-1.201.554L6.013 28.86a.735.735 0 0 0-.862 0l-1.728 1.248c-.497.36-1.18-.011-1.2-.554a.748.748 0 0 1 .037-.261l.695-2.019a.727.727 0 0 0-.267-.815L.961 25.211c-.575-.415-.28-1.4.431-1.4h2.135c.318 0 .6-.122.698-.422l.66-2.032a.72.72 0 0 1 .697-.504.72.72 0 0 1 .697.504l.66 2.032c.098.3.38.423.698.423h2.135c.71 0 1.006.984.43 1.4z"
              />
            </g>
          </g>
        </svg>
        <div class="nav-item-hover">{{ $t("components.nav_left.l_4") }}</div>
      </router-link>
      <router-link
        to="/projects"
        :class="[
          'nav-item',
          'fill',
          $route.path.includes('/projects') ||
          $route.path.includes('/finished-projects')
            ? 'active'
            : '',
        ]"
        v-if="checkUserAllowedModules(4)"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="29"
          height="27"
          viewBox="0 0 29 27"
        >
          <g>
            <g>
              <path
                d="M28.458 9.8l-1.472 15.355c-.068 1.033-.964 1.845-2.04 1.845H4.242c-1.023 0-1.898-.776-2.036-1.805l-.004-.039L.73 9.796c-.05-.378.065-.767.315-1.062a1.414 1.414 0 0 1 1.081-.499h1.141l-.385-2.501c-.066-.398.05-.81.322-1.132.27-.318.66-.5 1.07-.5h1.843l-.382-2.435A1.4 1.4 0 0 1 6.057.533c.27-.318.66-.501 1.07-.501h14.967c.41 0 .798.176 1.065.484.268.309.387.724.328 1.138L23.082 4.1h1.864c.41 0 .797.176 1.064.484.268.308.388.722.329 1.136l-.387 2.514h1.11c.419 0 .813.182 1.082.5.25.294.364.683.314 1.065zM8.31 4.101h12.576l.314-1.903H8.012zM5.46 8.235h18.3l.303-1.967H5.157zm20.764 2.166H2.964l1.384 14.436 20.493-.003zM9.472 15.374c0-.597.486-1.083 1.084-1.083h8.076c.598 0 1.084.486 1.084 1.083s-.486 1.083-1.084 1.083h-8.076a1.084 1.084 0 0 1-1.084-1.083z"
              />
            </g>
          </g>
        </svg>
        <div class="nav-item-hover">{{ $t("components.nav_left.l_5") }}</div>
      </router-link>
      <router-link
        to="/bulletin-board"
        :class="[
          'nav-item',
          'dont-fill',
          ['/bulletin-board'].includes($route.path) ? 'active' : '',
        ]"
        v-if="checkUserAllowedModules(5)"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="25"
          height="25"
          viewBox="0 0 25 25"
        >
          <g>
            <g>
              <path
                d="M24.46 13.36l-4.02 2.009 4.02 2.01a.978.978 0 0 1 0 1.748l-11.538 5.769a.978.978 0 0 1-.875 0L.51 19.127a.978.978 0 0 1 0-1.748l4.02-2.01-4.02-2.01a.978.978 0 0 1 0-1.749L4.53 9.6.51 7.59a.978.978 0 0 1 0-1.748L12.047.073a.978.978 0 0 1 .875 0L24.46 5.842a.978.978 0 0 1 0 1.749L20.44 9.6l4.02 2.01a.978.978 0 0 1 0 1.748zM3.134 6.715l9.35 4.675 9.352-4.675-9.351-4.675zm15.12 9.746l-5.332 2.665a.978.978 0 0 1-.875 0l-5.33-2.665-3.583 1.791 9.35 4.675 9.352-4.675zm3.582-3.977l-3.582-1.791-5.332 2.665a.978.978 0 0 1-.875 0l-5.33-2.665-3.583 1.79 9.35 4.676z"
              />
            </g>
          </g>
        </svg>
        <div class="nav-item-hover">{{ $t("components.nav_left.l_6") }}</div>
      </router-link>
      <router-link
        to="/naplata"
        :class="[
          'nav-item',
          'dont-fill',
          ['/izdane-fakture', '/naplata'].includes($route.path) ? 'active' : '',
        ]"
        v-if="checkUserAllowedModules(6)"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="25"
          height="22"
          viewBox="0 0 25 22"
          fill="none"
        >
          <rect
            x="1"
            y="1"
            width="23"
            height="20"
            rx="5"
            stroke="#2B2B41"
            stroke-width="2"
          />
          <path
            d="M8.1 11.28C8.1 16.2485 11.8357 17 13.4214 17C14.69 17 15.5357 16.7789 15.8 16.6683M7 13.0404L13.16 13.0404M8.1 11.72C8.1 6.75153 11.8357 6 13.4214 6C14.69 6 15.5357 6.22112 15.8 6.33168M7 10.4H13.16"
            stroke="#2B2B41"
            stroke-width="1.7"
            stroke-linecap="round"
          />
        </svg>
        <div class="nav-item-hover">{{ $t("components.nav_left.l_7") }}</div>
      </router-link>
      <router-link
        to="/crm"
        :class="[
          'nav-item',
          'dont-fill',
          ['/crm'].includes($route.path) ? 'active' : '',
        ]"
        v-if="checkUserAllowedModules(6)"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="23"
          height="32"
          viewBox="0 0 23 32"
        >
          <g>
            <g>
              <path
                d="M12.19 6.376a3.736 3.736 0 0 1 3.732-3.732 3.736 3.736 0 0 1 3.732 3.732 3.736 3.736 0 0 1-3.732 3.732 3.736 3.736 0 0 1-3.732-3.732zm2.488 0c0 .686.558 1.244 1.244 1.244.686 0 1.244-.558 1.244-1.244 0-.686-.558-1.244-1.244-1.244-.686 0-1.244.558-1.244 1.244zm7.463 8.645v5.473a3.738 3.738 0 0 1-2.487 3.519v6.743a1.244 1.244 0 1 1-2.488 0v-7.774c0-.687.557-1.244 1.244-1.244.685 0 1.244-.558 1.244-1.244v-5.473c0-.686-.559-1.244-1.244-1.244h-2.24a1.244 1.244 0 1 1 0-2.488h2.24a3.736 3.736 0 0 1 3.731 3.732zM0 12.533a3.736 3.736 0 0 1 3.732-3.732h4.975a3.736 3.736 0 0 1 3.732 3.732v6.78c0 .463-.086.908-.24 1.318a1.245 1.245 0 0 0 1.235 1.107c.687 0 1.244.557 1.244 1.244v7.774a1.244 1.244 0 0 1-2.488 0v-6.743a3.75 3.75 0 0 1-1.804-1.37c-.14.072-.285.135-.435.188v7.925a1.244 1.244 0 1 1-2.488 0V21.8c0-.687.557-1.244 1.244-1.244.686 0 1.244-.558 1.244-1.244v-6.779c0-.686-.558-1.244-1.244-1.244H3.732c-.686 0-1.244.558-1.244 1.244v6.78c0 .685.558 1.243 1.244 1.243.687 0 1.244.557 1.244 1.244v8.956a1.244 1.244 0 1 1-2.488 0v-7.912A3.739 3.739 0 0 1 0 19.325zm2.488-8.645A3.736 3.736 0 0 1 6.219.156a3.736 3.736 0 0 1 3.732 3.732A3.736 3.736 0 0 1 6.22 7.62a3.736 3.736 0 0 1-3.731-3.732zm2.488 0c0 .686.558 1.244 1.243 1.244.686 0 1.244-.558 1.244-1.244 0-.686-.558-1.244-1.244-1.244-.685 0-1.243.558-1.243 1.244z"
              />
            </g>
          </g>
        </svg>
        <div class="nav-item-hover">{{ $t("components.nav_left.l_8") }}</div>
      </router-link>
      <router-link
        to="/ured"
        :class="[
          'nav-item',
          'dont-fill',
          ['/ured'].includes($route.path) ? 'active' : '',
        ]"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="28"
          height="34"
          viewBox="0 0 28 34"
        >
          <g>
            <g>
              <path
                d="M4.893 17.377a2.497 2.497 0 0 1-.56-2.033L6.535 2.137A2.498 2.498 0 0 1 9.01.04h9.657c1.233 0 2.273.88 2.474 2.095l2.203 13.207a2.497 2.497 0 0 1-.56 2.033 2.5 2.5 0 0 1-1.915.887H6.809a2.508 2.508 0 0 1-1.916-.886zm1.782-1.644a.126.126 0 0 0 .03.108c.028.034.06.048.103.048H20.87a.128.128 0 0 0 .104-.048.127.127 0 0 0 .029-.11L18.8 2.524a.135.135 0 0 0-.133-.11H9.01a.133.133 0 0 0-.132.11zm20.908 2.458c0 .654-.533 1.187-1.188 1.187-.803 0-1.456.652-1.456 1.454v5.283c0 .655-.533 1.187-1.188 1.187h-8.725v4.23h4.76c.655 0 1.188.532 1.188 1.187 0 .654-.533 1.187-1.188 1.187H7.891a1.189 1.189 0 0 1-1.188-1.187c0-.655.533-1.187 1.188-1.187h4.76v-4.23H3.926a1.189 1.189 0 0 1-1.188-1.187v-5.283c0-.802-.653-1.454-1.456-1.454A1.189 1.189 0 0 1 .094 18.19c0-.655.533-1.187 1.188-1.187a3.837 3.837 0 0 1 3.733 2.972c.476-.212 1.001-.33 1.554-.33h14.539a3.81 3.81 0 0 1 1.553.33 3.837 3.837 0 0 1 3.734-2.972c.655 0 1.188.532 1.188 1.187zm-5.02 6.737v-1.454c0-.802-.652-1.455-1.455-1.455H6.568c-.802 0-1.455.653-1.455 1.455v1.454z"
              />
            </g>
          </g>
        </svg>
        <div class="nav-item-hover">{{ $t("components.nav_left.l_9") }}</div>
      </router-link>
      <router-link
        to="/sifarnik"
        v-if="checkUserAllowedModules(9)"
        :class="[
          'nav-item',
          'fill',
          [
            '/template-docx',
            '/sifarnik',
            '/tarife',
            '/troskovnik-report-edit',
          ].includes($route.path)
            ? 'active'
            : '',
        ]"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="26"
          height="31"
          viewBox="0 0 26 31"
        >
          <g>
            <g>
              <path
                d="M5.183 12.344c0-.615.5-1.115 1.115-1.115h4.253c.614 0 1.115.5 1.115 1.115s-.5 1.115-1.115 1.115H6.298c-.615 0-1.115-.5-1.115-1.115zm0 4.319c0-.615.5-1.115 1.115-1.115h8.24a1.116 1.116 0 0 1 0 2.23h-8.24c-.615 0-1.115-.5-1.115-1.115zm0 4.318c0-.615.5-1.115 1.115-1.115h8.24a1.116 1.116 0 0 1 0 2.23h-8.24c-.615 0-1.115-.5-1.115-1.115zm19.166 5.65a1.052 1.052 0 0 1-.549.117h-.021c-.363 0-.708-.137-.971-.386l-2.305-1.505v4.35a1.457 1.457 0 0 1-.724 1.334l-.011.006a1.252 1.252 0 0 1-1.537-.284l-1.671-1.532-2.122 1.889a1.445 1.445 0 0 1-1.929 0l-2.091-1.889-2.09 1.887a1.52 1.52 0 0 1-.95.381h-.023a1.444 1.444 0 0 1-.961-.382l-2.12-1.888-1.723 1.553a1.474 1.474 0 0 1-1.618.28l-.008-.003a1.622 1.622 0 0 1-.922-1.29L0 29.243V8.237A3.35 3.35 0 0 1 3.266 5.05h.722V3.734C3.987 2.094 5.456.759 7.26.759h14.917a2.966 2.966 0 0 1 .193.002c.768.032 1.477.36 1.997.926.518.562.787 1.293.758 2.057v21.542a1.41 1.41 0 0 1-.777 1.346zM20.503 8.259v14.056c.452 0 1.287.195 1.494.402l.899.826V3.713l.002-.02a.647.647 0 0 0-.685-.704H7.26c-.504 0-1.044.3-1.044.746V5.05h11.344c1.65 0 2.942 1.409 2.942 3.208zM2.23 27.489l.979-.865a1.542 1.542 0 0 1 2.012-.044l.014.011 2.124 1.891 2.102-1.897.01-.009a1.52 1.52 0 0 1 .947-.332c.342 0 .678.118.946.332l.011.01 2.07 1.894 2.119-1.886a1.377 1.377 0 0 1 1.916.048l.793.776V8.258c0-.475-.25-.978-.712-.978H3.284c-.55.025-.999.452-1.054.998z"
              />
            </g>
          </g>
        </svg>
        <div class="nav-item-hover">{{ $t("components.nav_left.l_10") }}</div>
      </router-link>
      <router-link
        to="/analitika"
        :class="[
          'nav-item',
          'fill',
          [
            '/analitika'
          ].includes($route.path)
            ? 'active'
            : '',
        ]"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="29"
          height="29"
          viewBox="0 0 29 29"
        >
          <g>
            <g>
              <path
                d="M28.367 13.242a1.066 1.066 0 0 1-1.062.995H15.84a1.065 1.065 0 0 1-1.064-1.064V1.72c0-.56.438-1.026.996-1.062.264-.017.531-.025.793-.025 1.434 0 2.836.254 4.169.755a11.809 11.809 0 0 1 7.633 11.854zm-2.11-1.133A9.633 9.633 0 0 0 23.42 5.6a9.648 9.648 0 0 0-6.515-2.835v9.344zm-2.612 4.282a11.784 11.784 0 0 1-4.997 10.454A11.772 11.772 0 0 1 11.835 29c-3.161 0-6.133-1.23-8.369-3.463A11.743 11.743 0 0 1 0 17.175a11.74 11.74 0 0 1 3.466-8.362 11.759 11.759 0 0 1 8.366-3.464c.261 0 .526.009.788.026.558.035.996.502.996 1.061v8.96h8.967c.56 0 1.026.437 1.062.995zm-10.029 1.132v9.187a9.77 9.77 0 0 0 5.499-3.115 9.654 9.654 0 0 0 2.421-6.072zm-7.85 7.22a9.567 9.567 0 0 0 5.721 2.124v-7.84zm-.794-14.426a9.628 9.628 0 0 0-2.843 6.858c0 2.206.756 4.354 2.131 6.065l7.227-7.221V7.482a9.648 9.648 0 0 0-6.515 2.835z"
              />
            </g>
          </g>
        </svg>
        <div class="nav-item-hover">{{ $t("components.nav_left.l_11") }}</div>
      </router-link>
      
      <router-link
        to="/knowledge-management"
        :class="[
          'nav-item',
          'fill',
          [
            '/knowledge-management'
          ].includes($route.path)
            ? 'active'
            : '',
        ]"
      >
      <svg
          xmlns="http://www.w3.org/2000/svg"
          width="25"
          height="27"
          viewBox="0 0 25 27"
        >
          <g>
            <g>
              <path
                d="M25 20.25c0 2.617-2.143 4.746-4.777 4.746a4.771 4.771 0 0 1-2.638-.791l-2.503 2.486a1.062 1.062 0 0 1-.75.309c-.273 0-.544-.103-.751-.31a1.05 1.05 0 0 1 0-1.49l2.538-2.523a4.693 4.693 0 0 1-.673-2.427c0-2.617 2.143-4.746 4.777-4.746 2.634 0 4.777 2.129 4.777 4.746zm-2.123 0a2.648 2.648 0 0 0-2.654-2.637 2.648 2.648 0 0 0-2.654 2.637 2.648 2.648 0 0 0 2.654 2.637 2.648 2.648 0 0 0 2.654-2.637zm-9.873 1.476c0 .583-.475 1.055-1.061 1.055H3.185a1.06 1.06 0 0 0-1.062 1.055 1.06 1.06 0 0 0 1.062 1.055h6.422c.587 0 1.062.472 1.062 1.054 0 .583-.475 1.055-1.062 1.055H3.185C1.429 27 0 25.58 0 23.836V3.164C0 1.419 1.43 0 3.185 0h18.63c.587 0 1.062.472 1.062 1.055v10.968c0 .583-.475 1.055-1.062 1.055a1.058 1.058 0 0 1-1.061-1.055V2.11H3.184a1.06 1.06 0 0 0-1.06 1.055v17.69c.331-.118.689-.182 1.06-.182h1.062V5.273c0-.582.476-1.054 1.062-1.054.586 0 1.061.472 1.061 1.054v15.399h5.574c.586 0 1.061.472 1.061 1.054z"
              />
            </g>
          </g>
        </svg>
        <div class="nav-item-hover">{{ $t('components.nav_left.knowledge_management') }}</div>
      </router-link>
     
      <!-- Multi-window toggle -->
      <div
        class="nav-item multi-window-btn"
        @click="openNewWindow()"
        :title="$t('components.nav_left.open_new_window')"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <rect x="2" y="3" width="20" height="14" rx="2" ry="2"></rect>
          <line x1="8" y1="21" x2="16" y2="21"></line>
          <line x1="12" y1="17" x2="12" y2="21"></line>
          <path d="M9 9h6M9 13h6M15 9v4"></path>
        </svg>
        <div class="nav-item-hover">{{ $t('components.nav_left.open_new_window') }}</div>
      </div>

      <div class="localization-wrapper">
        <span
          :class="[selected_lang == 'hr' ? 'active' : '', 'lang-circle']"
          @click="changeLanguage('hr')"
          >hr</span
        >
        <div class="localization-vertical-divider"></div>
        <span
          :class="[selected_lang == 'en' ? 'active' : '', 'lang-circle']"
          @click="changeLanguage('en')"
          >en</span
        >
      </div>
      <!-- <div @click="getDesktopApp()" to="#" class="nav-item download-desktop">
        <svg
          width="25"
          height="27"
          viewBox="0 0 25 27"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_1712_3569)">
            <path
              d="M21.875 2.25H3.12499C1.97916 2.25 1.04166 3.2625 1.04166 4.5V18C1.04166 19.2375 1.97916 20.25 3.12499 20.25H10.4167L8.33332 23.625V24.75H16.6667V23.625L14.5833 20.25H21.875C23.0208 20.25 23.9583 19.2375 23.9583 18V4.5C23.9583 3.2625 23.0208 2.25 21.875 2.25ZM21.875 15.75H3.12499V4.5H21.875V15.75Z"
              fill="#E5103E"
            />
            <path
              d="M11.4909 5.90625V8.75391H9.73306L12.3698 11.6016L15.0065 8.75391H13.2487V5.90625H11.4909ZM8.85416 12.5508V13.5H15.8854V12.5508H8.85416Z"
              fill="#E5103E"
            />
          </g>
          <defs>
            <clipPath id="clip0_1712_3569">
              <rect width="25" height="27" fill="white" />
            </clipPath>
          </defs>
        </svg>
        <div class="nav-item-hover">Download Firmwide desktop</div>
      </div> -->
      <div
        v-if="release_notes.length > 0"
        class="version-wrappper"
        @click="openReleaseNotes()"
      >
        <span>v {{ release_notes[0].version }}</span>
      </div>
      <div v-if="$store.state.release_notes_open">
        <!-- kak sam pametan to nisu istine -->
        <!-- ovo moram i na druga mesta staviti gde imamo dialog koji bi se na outside click trebal vgasiti-->
        <div class="blank-background" @click="closeReleaseNotes()"></div>
        <release-notes
          @closeReleaseNotes="closeReleaseNotes()"
          @reloadNotes="reloadNotes()"
          :release_notes="release_notes"
        ></release-notes>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import gsap from "gsap";
import ReleaseNotes from "@/components/generalComponents/ReleaseNotes/ReleaseNotes.vue";
import DataLoader from "@/components/generalComponents/DataLoader";
import admin from "@/apiCallers/promise_handler_db/admin";

export default {
  components: { ReleaseNotes, DataLoader },
  mounted() {
    //nav item hovers
    $(".nav-item").hover(
      function () {
        gsap.to($(this).find(".nav-item-hover"), 0.5, {
          display: "flex",
          opacity: 1,
          left: "5rem",
        });
        // gsap.to($(this).find('svg path'),0.3,{fill:'#3325ae'})
      },
      function () {
        gsap.to($(this).find(".nav-item-hover"), 0.5, {
          display: "none",
          opacity: 0,
          left: "4rem",
        });
        // gsap.to($(this).find('svg path'),0.3,{fill:'#2b2b41'})
      }
    );
  },
  methods: {
    /**
     * A responsive checker that will check if a user can access the module.
     * @param {*} mod_id
     */
    checkUserAllowedModules: function (mod_id) {
      if (this.$store.state.logged_in_user != undefined) {
        return this.$store.state.logged_in_user.user_role.allowed_modules.includes(
          mod_id
        );
      } else return false;
    },
    getDesktopApp: async () => {
      var link = document.createElement("a");
                                link.href = "https://app-psod.cratis.cloud/LegalleriaFirmwide.2.0.2-win.exe";
                                link.target = "_blank";
      if (navigator.userAgent.indexOf("Mac OS X") != -1) {
        link.href = "https://app-psod.cratis.cloud/LegalleriaFirmwide.2.0.2-osx.dmg";
      }

      link.click();

      // await admin
      //   .getDesktopApplication()
      //   .then((response) => {
      //     console.log(response)
      //     const contentDisposition = response.headers["content-disposition"];
      //     const regex = /filename=([^;]*)/; // Extract the filename from the content-disposition header

      //     if (contentDisposition && regex.test(contentDisposition)) {
      //       const matches = contentDisposition.match(regex);
      //       const filename = matches[1];
      //       const contentType = response.headers["content-type"];

      //       var newBlob = new Blob([response.data], {
      //                               type: contentType,
      //                           });
      //                           console.log
      //                           var data = window.URL.createObjectURL(newBlob);

      //                           var link = document.createElement("a");
      //                           link.href = data;
      //                           link.download = filename;
      //                           link.type = contentType
      //                           link.click();
      //       // const a = document.createElement("a");
      //       // document.body.appendChild(a);
      //       // a.style = "display: none";

      //       // // Create a blob URL and simulate a click to trigger the download
      //       // const blob = response.data;
      //       // const url = window.URL.createObjectURL(blob);
      //       // a.href = url;
      //       // a.download = filename;
      //       // a.type = contentType;
      //       // a.click();

      //       // window.URL.revokeObjectURL(url);

      //     } else {
      //       console.error("File information not found in response headers.");
      //     }
      //   })
      //   .catch((error) => {
      //     console.error("File download failed:", error);
      //   });
    },
    openReleaseNotes() {
      this.$store.state.release_notes_open = true;
    },
    closeReleaseNotes() {
      this.$store.state.release_notes_open = false;
    },
    changeLanguage(value) {
      localStorage.setItem("lang", value);
      this.$store.state.is_intentional_reload = true;
      window.location.reload();
    },
    linkToUserRoot() {
      this.$router.push(
        this.$store.state.logged_in_user.user_role.default_route
      );
    },
    openNewWindow() {
      const currentPath = this.$route.fullPath;
      const width = Math.min(1400, window.screen.width - 100);
      const height = Math.min(900, window.screen.height - 100);
      const left = (window.screen.width - width) / 2;
      const top = (window.screen.height - height) / 2;

      window.open(
        currentPath,
        '_blank',
        `width=${width},height=${height},left=${left},top=${top},menubar=no,toolbar=no,location=no,status=no`
      );
    },
    async reloadNotes() {
      await admin.getReleaseNotes().then((resp) => {
        this.release_notes = resp.data;
      });
    },
  },
  data() {
    const lang = localStorage.getItem("lang") || "hr";
    return {
      selected_lang: lang,
      release_notes: [],
    };
  },
  async created() {
    if (this.release_notes.length == 0) {
      this.reloadNotes();
    }
  },
  destroyed() {
    $(".mobile-menu-wrapper").off();
    $(".nav-item").off();
  },
};
</script>

<style></style>
